module.exports = __webpack_public_path__ + "img/17.47f4e901.jpg";